import * as React from "react";
import * as PropTypes from "prop-types";
import { BREAK_POINTS, Link } from "@origin-digital/style-guide";
import { QuestionMarkOutlineIcon } from "@origin-digital/icon";
import styled, { StyledComponentClass } from "styled-components";
import Logo from "../Logo";
import Toolbar from "../Toolbar";
import MobileToolbar from "../MobileToolbar";
import HeaderbarBottom from "./HeaderbarBottom";
import OverlayNav from "../OverlayNav";
import Navbar from "../Navbar";
import { logout } from "../../../../auth/logout";
import {
  NavStructurePropTypes,
  Palette,
  ToolbarItemsPropTypes
} from "../../vars";

const ResponsiveWrapper: StyledComponentClass<any, any> = styled.div`
  display: ${({ isMobile }: any) => (isMobile ? "block" : "none")};

  ${({ isMobile }: any) => (isMobile ? "position: relative;" : "")};

  @media (min-width: ${BREAK_POINTS.Min.LG}) {
    display: ${({ isMobile }: any) => (isMobile ? "none" : "block")};
  }
`;

const ToolbarIcon = styled.div`
  border-left: 1px solid ${Palette.Rebrand.Colours.G3};

  a {
    display: inline-block;
    line-height: 64px;
    width: 64px;
    text-align: center;

    svg {
      margin-bottom: 2px;
    }

    &:hover svg {
      color: ${Palette.Rebrand.Colours.P1};
    }
  }
`;

const HELP_AND_SUPPORT_PATH = "/help-support";

class Headerbar extends React.Component<any, any> {
  static propTypes = {
    ...NavStructurePropTypes,
    ...ToolbarItemsPropTypes,
    logoutUrl: PropTypes.string
  };

  static defaultProps = {
    logoutUrl: "/"
  };

  static getDerivedStateFromProps(props, state) {
    if (
      typeof window !== "undefined" &&
      state.toolbarItems.length !== props.toolbarItems.length
    ) {
      const DASHBOARD_PATH = "/my-account/dashboard";
      const isDashboardActive = window.location.pathname.includes(
        DASHBOARD_PATH
      );
      const isHelpAndSupportActive = window.location.pathname.includes(
        HELP_AND_SUPPORT_PATH
      );
      const { toolbarItems } = props;
      const activeToolbarItems = toolbarItems.map(item => {
        if (
          (item.href === DASHBOARD_PATH && isDashboardActive) ||
          (item.href === HELP_AND_SUPPORT_PATH && isHelpAndSupportActive)
        ) {
          return { ...item, isActive: true };
        }
        return item;
      });

      return {
        menuOpen: state.menuOpen,
        toolbarItems: activeToolbarItems
      };
    }
    return {
      menuOpen: state.menuOpen,
      toolbarItems: props.toolbarItems
    };
  }

  constructor(props) {
    super(props);

    this.state = {
      menuOpen: false,
      toolbarItems: []
    };
  }

  openMenu = () => ({ menuOpen: true });

  closeMenu = () => ({ menuOpen: false });

  handleMenuToggleClick = () => {
    this.setState(this.openMenu);
  };

  handleCloseMenuClick = () => {
    this.setState(this.closeMenu);
  };

  handleLogoutClick = () => {
    logout();
  };

  render() {
    const { navStructure, className } = this.props;

    return (
      <div
        id="my-account-nav"
        data-id="my-account-nav"
        data-logout-url={this.props.logoutUrl}
        className={className}
        role="navigation"
      >
        <Logo absolute />

        <ResponsiveWrapper isMobile={true}>
          <MobileToolbar onMenuToggleClick={this.handleMenuToggleClick}>
            <ToolbarIcon>
              <Link href={HELP_AND_SUPPORT_PATH} data-id="help-mobile">
                <QuestionMarkOutlineIcon size="32" color="grey48" />
              </Link>
            </ToolbarIcon>
          </MobileToolbar>
          <OverlayNav
            open={this.state.menuOpen}
            onCloseMenuClick={this.handleCloseMenuClick}
            onLogoutClick={this.handleLogoutClick}
            navStructure={navStructure}
          />
        </ResponsiveWrapper>
        <ResponsiveWrapper isMobile={false}>
          <Toolbar items={this.state.toolbarItems} />
          <HeaderbarBottom>
            <Navbar navStructure={navStructure} />
          </HeaderbarBottom>
        </ResponsiveWrapper>
      </div>
    );
  }
}

export default Headerbar;
